import {defineStore} from "pinia";
import type {Customer} from "~/models/customers";
import {useLocalStorage} from "@vueuse/core";

export const useCustomersStore = defineStore('customers', () => {
  const favorites = useLocalStorage('favoriteCustomers', [] as Array<Customer['Id']>)
  const searchTerm = ref('')

  const favoriteIds = computed(() => favorites.value)

  const addFavorite = (id: Customer['Id']): void => {
    favorites.value.push(id)
  }
  const removeFavorite = (id: Customer['Id']): void => {
    favorites.value = favorites.value.filter(i => i !== id)
  }

  return {
    favorites,
    searchTerm,
    favoriteIds,
    addFavorite,
    removeFavorite,
  }
})